import { fetchThingMetaByGameIds } from './bggThingMeta'

function gameObjectId(game) {
	if (!game || game['@_objectid'] == null) return ''
	return String(game['@_objectid'])
}

function mergeThingCovers(game, metaById) {
	const id = gameObjectId(game)
	if (!id) return game
	const m = metaById.get(id)
	if (!m) return game
	const next = { ...game }
	if (m.image) next.image = m.image
	if (m.thumbnail) next.thumbnail = m.thumbnail
	return next
}

/**
 * Shallow-clones roll pool entries with `image` / `thumbnail` from `/thing` (`stats=1`, shared with ThingMeta cache).
 * On total failure returns the original array reference.
 */
export async function enrichRollPoolWithThingCovers(rollPool) {
	if (!rollPool || !rollPool.length) return rollPool
	try {
		const seen = new Set()
		const ids = []
		for (const g of rollPool) {
			const id = gameObjectId(g)
			if (!id || seen.has(id)) continue
			seen.add(id)
			ids.push(id)
		}
		const metaById = await fetchThingMetaByGameIds(ids)
		if (metaById.size === 0) return rollPool
		return rollPool.map((g) => mergeThingCovers(g, metaById))
	} catch {
		return rollPool
	}
}
